module.exports = __webpack_public_path__ + "static/media/internship-cover-Desktop.17ed3af2.png";